import { render, staticRenderFns } from "./MarstonWarning.vue?vue&type=template&id=56ead05c"
import script from "./MarstonWarning.vue?vue&type=script&lang=js"
export * from "./MarstonWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports